import "./login-button.css";
const LoginButton = ({ sign, onClick }) => {
  const isLocalDev = process.env.NODE_ENV === "development";
  const imageSrc = isLocalDev
    ? "../BankID_logo.png"
    : "/wp-content/themes/socionomen/dist/images/BankID_logo.png";

  const buttonText = sign ? "BESTÄLL" : "LOGGA IN";

  return (
    <>
      <button id="baid-login-button" onClick={onClick}>
        <img src={imageSrc} alt={"BankID logo"} id="baid-logo" />
        <span id="login-button-text">{buttonText}</span>
      </button>
    </>
  );
};
export { LoginButton };
